import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ContactModel, FilterParams, StarbaseComponentMessage, StarbaseDataService } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';
import { ContactEmail_ext } from '../models/contact-email-ext';
import { StarbaseComponentMessageService } from './starbase-component-message.service';

@Injectable({
  providedIn: 'root'
})
export class ContactEmailService extends StarbaseDataService<ContactEmail_ext> {
  public currentContactId: number;
  public currentContactObj: ContactModel;

  protected _staleDataTimeout = 2500;
  protected _getOneUri: string;
  protected _getAllUri = '/api/ContactEmails/GetByContact?contactId=';
  protected _postUri = '/api/ContactEmails';
  protected _putUri = '/api/ContactEmails/';
  protected _deleteUri = '/api/ContactEmails/';
  protected _broadSearchUri: string;

  constructor(private sbCmpMsg: StarbaseComponentMessageService, private _http: HttpClient, _webApiSvc: WebApiService) {
    super(_http, _webApiSvc);
  }

  getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<ContactEmail_ext>): Observable<FilterParams<ContactEmail_ext>> {
    throw new Error('Method not implemented.');
  }

  public getAllData(url: string, retryCount: number = null): Observable<ContactEmail_ext[]> {
    if (this.currentContactId === 0) {
      return of([]);
    }
    url = this.getAllUri + this.currentContactId;
    this.forceStaleData();
    return super.getAllData(url, retryCount);
  }

  // override to intercept posted object and add in correct contact Id
  public postData(url: string, postObject: ContactEmail_ext): Observable<ContactEmail_ext> {
    if (this.currentContactId === 0) {
      if (!this.currentContactObj.commTypesPhone) {
        this.currentContactObj.commTypesPhone = [];
      }
      this.currentContactObj.commTypesEmail.push(postObject);
      this.sbCmpMsg.handleStarbaseComponentMsg(
        StarbaseComponentMessage.errorMessageForUser(
          'Cannot save phone number',
          'Please save your new contact first, then try again.'));
      return of();
    }
    postObject.contactUID = this.currentContactId;
    return super.postData(url, postObject);
  }

}
